module.exports = __webpack_public_path__ + "fonts/iconfont.230d6e7a.woff";